<template>
  <wo-region v-if="user">
    <wo-layout>
      <wo-title tag-name="h3" v-t="'admin.user.editTitle'" />
    </wo-layout>
    <user-edit :value="user" @input="confirm" @cancel="confirm" />
  </wo-region>
</template>

<script>

import { mapState } from 'vuex'
import { ADMIN_USER } from '@/routes/admin'

import { userRepository } from '@/repository/identity'

import UserEdit from '@/components/identity/UserEdit'

export default {
  components: { UserEdit },
  props: {
    userId: [Number, String]
  },
  computed: mapState({
    user: state => state.identity.user
  }),
  created () {
    this.loadUser()
  },
  methods: {
    loadUser () {
      this.$store.dispatch(userRepository.find, { id: this.userId })
    },
    confirm () {
      this.$router.push({ name: ADMIN_USER })
    }
  }
}
</script>
